export default __webpack_public_path__ + "assets/logo-black-381c2b6442e3c31638c0d2ffe8aa733f.svg";